export const MEAL_TYPES = ['breakfast', 'lunch', 'dinner', 'snack'];
export const LEFTOVER_POLICIES = [
  { value: 'encourage', label: 'Encourage repeats (use leftovers soon)' },
  { value: 'neutral', label: 'Neutral (no leftover push)' },
  { value: 'manual_only', label: 'Manual only (you schedule repeats)' },
  { value: 'freeze_inventory', label: 'Freezer / pantry (save leftovers for later)' }
];
export const PANTRY_SUGGEST_MODES = [
  { value: 'off', label: 'Off' },
  { value: 'suggest', label: 'Suggest pantry items when planning' }
];

const DEFAULT_MEAL_PREFERENCE = {
  portionsPerMeal: 2,
  varietyWindowDays: 14,
  leftoverPolicy: 'encourage',
  suggestFromPantry: 'off',
  leftoverMinGapDays: 30
};

const DEFAULT_LUNCH_PREFERENCE = {
  portionsPerMeal: 2,
  varietyWindowDays: 1,
  leftoverPolicy: 'encourage',
  suggestFromPantry: 'off',
  leftoverMinGapDays: 1
};

export function defaultPlanningPreferences() {
  return Object.fromEntries(
    MEAL_TYPES.map((mealType) => [
      mealType,
      mealType === 'lunch' ? { ...DEFAULT_LUNCH_PREFERENCE } : { ...DEFAULT_MEAL_PREFERENCE }
    ])
  );
}

export function normalizeMealPreference(pref, fallback, mealType = null) {
  const base = fallback || DEFAULT_MEAL_PREFERENCE;
  if (!pref || typeof pref !== 'object') {
    return { ...base };
  }
  let leftoverPolicy = LEFTOVER_POLICIES.some((p) => p.value === pref.leftoverPolicy)
    ? pref.leftoverPolicy
    : base.leftoverPolicy;
  if (mealType === 'lunch' && leftoverPolicy === 'freeze_inventory') {
    leftoverPolicy = 'encourage';
  }
  return {
    portionsPerMeal: Math.max(1, Number(pref.portionsPerMeal) || base.portionsPerMeal),
    varietyWindowDays: Math.max(0, Number(pref.varietyWindowDays ?? base.varietyWindowDays)),
    leftoverPolicy,
    suggestFromPantry: PANTRY_SUGGEST_MODES.some((p) => p.value === pref.suggestFromPantry)
      ? pref.suggestFromPantry
      : base.suggestFromPantry,
    leftoverMinGapDays: Math.max(
      0,
      Number(pref.leftoverMinGapDays ?? base.leftoverMinGapDays ?? 0)
    )
  };
}

export function normalizePlanningPreferences(input) {
  const defaults = defaultPlanningPreferences();
  if (!input || typeof input !== 'object') {
    return defaults;
  }
  const result = { ...defaults };
  for (const mealType of MEAL_TYPES) {
    result[mealType] = normalizeMealPreference(input[mealType], defaults[mealType], mealType);
  }
  return result;
}

export const RECIPE_PLANNING_BEHAVIORS = [
  { value: 'default', label: 'Use my meal-type default' },
  ...LEFTOVER_POLICIES
];
